import axios from 'axios';

import Constants from './Constants';
import { getHTTPHeaders } from './common';

const EventService = () => {
  const EVENTS_URL = Constants.EVENTS.URL;

  const _headers = (accessToken) => ({
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const addEvent = (evnt) => {
    return axios.post(
      `${EVENTS_URL}/eventAdd?eventType=${evnt[0].eventType}`,
      evnt,
      getHTTPHeaders()
    );
  };

  const lastEvent = (accessToken, query) =>
    axios.post(
      `${EVENTS_URL}/eventView?eventType=${query.eventType}`,
      query,
      _headers(accessToken)
    );

  const eventsByType = (accessToken, eventType) =>
    axios.post(
      `${EVENTS_URL}/eventsByType/${eventType}`,
      {},
      _headers(accessToken)
    );

  const feedback = (accessToken, feedback) =>
    axios.post(`${EVENTS_URL}/feedback`, feedback, _headers(accessToken));

  const getFeedbacks = (accessToken) =>
    axios.get(`${EVENTS_URL}/feedback`, _headers(accessToken));

  const getEventsScenariosInputs = (accessToken, planId) =>
    axios.get(
      `${EVENTS_URL}/portfolio/scenarios/${planId}`,
      _headers(accessToken)
    );

  const saveEventsScenariosInputs = (accessToken, planId, scenariosInputs) =>
    axios.post(
      `${EVENTS_URL}/portfolio/scenarios/${planId}`,
      scenariosInputs,
      _headers(accessToken)
    );

  return {
    addEvent,
    lastEvent,
    feedback,
    getFeedbacks,
    eventsByType,
    getEventsScenariosInputs,
    saveEventsScenariosInputs,
  };
};

export default EventService;
